import mtSmartThumbnailImageUrl from 'static/images/GoMediaStadium_SolarPanelCompletion.jpg';
import northHarbourThumbnailImageUrl from 'static/images/NthHarbourStadium.jpg';
import westernSpringsThumbnailImageUrl from 'static/images/western_springs_panorama.jpg';

export default [
    {
        label: 'Go Media Stadium',
        pageLink: '/our-venues/go-media-stadium',
        directionsLink: 'https://www.google.com/maps/search/?api=1&query=Mt+Smart+Stadium&query_place_id=ChIJVeEWutdIDW0RGEROrR2Oeco',
        thumbnailImageUrl: mtSmartThumbnailImageUrl,
        detail: 'Auckland’s home of live sport and entertainment, Go Media Stadium is New Zealand’s busiest sporting venue.',
        socials: [
            {
                label: 'instagram',
                link: 'https://www.instagram.com/gomedia_stadium/',
                icon: 'instagram'
            },
            {
                label: 'facebook',
                link: 'https://www.facebook.com/gomediastadium/',
                icon: 'facebook'
            },
            {
                label: 'tiktok',
                link: 'https://www.tiktok.com/@gomediastadium',
                icon: 'tiktok'
            }
        ]
    },
    {
        label: 'Western Springs Bowl',
        pageLink: '/our-venues/western-springs-bowl',
        directionsLink: 'https://www.google.com/maps/search/?api=1&query=Western+Springs+Stadium+and+Park&query_place_id=ChIJZUa9rg5HDW0Ryad_qWEF3Zw',
        thumbnailImageUrl: westernSpringsThumbnailImageUrl,
        detail: 'Located just 3 kilometres from downtown Tāmaki Makaurau Auckland, Western Springs Bowl is a dedicated outdoor music and sport arena built into a unique natural amphitheatre.',
        socials: [
            {
                label: 'instagram',
                link: 'https://www.instagram.com/westernspringsbowl/',
                icon: 'instagram'
            },
            {
                label: 'facebook',
                link: 'https://www.facebook.com/westernspringsbowl/',
                icon: 'facebook'
            },
            {
                label: 'tiktok',
                link: 'https://www.tiktok.com/@westernspringsbowl',
                icon: 'tiktok'
            }
        ]
    },
    {
        label: 'North Harbour Stadium',
        pageLink: '/our-venues/north-harbour-stadium',
        directionsLink: 'https://www.google.com/maps/search/?api=1&query=North+Harbour+Stadium&query_place_id=ChIJsaB0vZM7DW0RW2eN7EWwYvs',
        thumbnailImageUrl: northHarbourThumbnailImageUrl,
        detail: 'Located in Albany on Auckland\'s North Shore, North Harbour Stadium is purpose-built for New Zealand\'s favourite sporting codes of rugby and football.',
        socials: [
            {
                label: 'instagram',
                link: 'https://www.instagram.com/northharbourstadium/',
                icon: 'instagram'
            },
            {
                label: 'facebook',
                link: 'https://www.facebook.com/NorthHarbourStadium/',
                icon: 'facebook'
            }
        ]
    }
];
